/* eslint-disable @mizdra/layout-shift/require-size-attributes */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
// import { params, string, shape, bool } from '@thd-nucleus/data-sources';
import {
  params,
  string,
  shape,
  bool,
  customType,
  number as numberType,
  fragment,
  string as stringType,
  useDataModel,
} from '@thd-nucleus/data-sources';
import '../css/calc-link.scss';

const CalcLink = ({ itemId }) => {

  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('moving-calculator-link.ready'); }, []);
  const { data, loading, error } = useDataModel('product', { variables: { itemId } });
  if (!data || loading || error) {
    return null;
  }

  const { movingCalculatorEligible } = data?.product?.info || {};
  if (!movingCalculatorEligible) return null;

  return (
    <div className="moving-calculator__link-wrapper" data-testid="calc-link">
      <div className="moving-calculator__link-text">
        <img
          className="moving-calculator__link-icon"
          src="https://assets.thdstatic.com/images/v1/calculator-orange.svg"
          alt="calculator icon"
        />
        <div>
          <div className="moving-calculator__link-text--header">
            Getting ready for your move?
          </div>
          <div className="moving-calculator__link-text--body">
            Calculate how many supplies you need
          </div>
        </div>
      </div>
      <div className="moving-calculator__link-button-wrapper">
        <a href="https://www.homedepot.com/c/moving-box-calculator" className="bttn-outline bttn-outline--dark">
          <span className="bttn__content">
            Calculate Now
          </span>
        </a>
      </div>
    </div>
  );
};

CalcLink.displayName = 'CalcLink';

CalcLink.dataModel = {
  product: params({ itemId: string().isRequired() }).shape({
    itemId: string(),
    info: shape({
      movingCalculatorEligible: bool()
    })
  })
};

CalcLink.propTypes = {
  itemId: PropTypes.string,
};

CalcLink.defaultProps = {
  itemId: null
};

export { CalcLink };